import { useSelector } from '@xstate/react'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useOptimizelyExperiment from './Optimizely/useOptimizelyExperiment'

export const useSharedCartFeatureFlag = () => {
  const isSharedCartsEnabled = useOptimizelyExperiment(OptimizelyFeatureFlags.croSharedCarts)
  const multiCartActorRef = MultiCartContext.useActorRef()
  const hasMultipleCarts = useSelector(multiCartActorRef, (snapshot) => {
    if (snapshot.context.cartSummary.status !== 'loaded') {
      return false
    }

    return Object.keys(snapshot.context.cartSummary.data).length > 0
  })

  return isSharedCartsEnabled || hasMultipleCarts
}
